import React, {useEffect, useRef, useState} from "react";

const TimeField = (props) => {

  const {
    name,
    value,
    required,
    onChange,
  } = props;

  const [show, setShow] = useState(false);
  const [h, setH] = useState();
  const [m, setM] = useState();
  const hours = Array.from({ length: 24 }, (_, i) => i < 10 ? `0${i}` : i);
  const minutes = ['00', 10, 20, 30, 40, 50];
  const ref = useRef();

  useEffect(() => {
    window.addEventListener('click', (e) => {
      if (ref.current) {
        if (!ref.current.contains(e.target)) {
          setShow(false);
        }
      }
    });

    if (value) {
      const dt = new Date(`1970-01-01T${value}`);
      setH(dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours());
      setM(dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes());
    }
  }, []);

  useEffect(() => {
    if (h && !m) {
      setM('00');
    }
    if (h && m) {
      const dt = new Date();
      dt.setHours(h);
      dt.setMinutes(m);
    }
    onChange(h && m ? `${h}:${m}:00` : null);
  }, [h, m]);



  return <div className={`time-field`} ref={ref}>
    <input
      name={name}
      type="time"
      aria-labelledby="time"
      // value={`${h}:${m}:00`}
      value={h && m ? `${h}:${m}:00` : null}
      required={required}
      onClick={(e) =>{
        e.preventDefault();
        setShow(true);
      }}
    />

    {show && <div className={`time-field__dd`}>
      <div>
        <ul>
          {hours.map((i) => {
            return <li
              key={i}
              onClick={() => {
                setH(i)
              }}
              className={i === h ? 'active' : ''}
            >{i}</li>
          })}
        </ul>
        <ul>
          {minutes.map((i) => {
            return <li
              key={i}
              className={i === m ? 'active' : ''}
              onClick={() => {
                setM(i)
              }}>{i}</li>
          })}
        </ul>
      </div>
    </div>}
  </div>

}

export default TimeField;
